import React from 'react';
import Button from 'components/Button';
import s from './styles.module.scss';

function App() {
  return (
    <div className={s.wrapper}>
      <header className={s.content}>
        <img srcSet="/images/virtues.png 1x, /images/virtues@2x.png 2x" alt="" />
        <h1>Welcome to “VIRTUES”</h1>
        <Button component="a" href="https://rpm-cied.virtuescare.app/">
          <span className={s.buttonTitle}>RPM-CIED</span>
          <span className={s.buttonSubTitle}>Remote Monitored Devices</span>
        </Button>
      </header>
    </div>
  );
}

export default App;
